(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6900],{

/***/ 84297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createLucideIcon; }
});

// UNUSED EXPORTS: toKebabCase

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */




const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim();
const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, ...rest }, ref) => {
      return (0,react.createElement)(
        "svg",
        {
          ref,
          ...defaultAttributes,
          width: size,
          height: size,
          stroke: color,
          strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
          className: ["lucide", `lucide-${toKebabCase(iconName)}`, className].join(" "),
          ...rest
        },
        [
          ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
          ...Array.isArray(children) ? children : [children]
        ]
      );
    }
  );
  Component.displayName = `${iconName}`;
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map


/***/ }),

/***/ 8971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronDown; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * @license lucide-react v0.314.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronDown = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);


//# sourceMappingURL=chevron-down.js.map


/***/ }),

/***/ 89498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies",
      function () {
        return __webpack_require__(33077);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FivaLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51146);
/* harmony import */ var _components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31552);



function FivaLayout(param) {
    var children = param.children, blue = param.blue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                blue: blue
            })
        ]
    });
}


/***/ }),

/***/ 33077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cookies; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./Layout/FivaLayout.tsx
var FivaLayout = __webpack_require__(32399);
;// CONCATENATED MODULE: ./components/CookiesComponent/CookiesComponent.tsx

var CookiesComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            padding: "1% 10%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Cookie Policy for Fiva"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "This is the Cookie Policy for Fiva, accessible from https://fiva.es/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "What Are Cookies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the site's functionality."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "How We Use Cookies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "Disabling Cookies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "The Cookies We Set"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Forms related cookies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "When you submit data to through a form such as those found on contact pages or comment forms cookies may be set to remember your user details for future correspondence."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "Third Party Cookies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "For more information on Google Analytics cookies, see the official Google Analytics page."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "More Information"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "However if you are still looking for more information then you can contact us through one of our preferred contact methods:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Email: contacto@fiva.es"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "By visiting this link: https://fiva.es/contacto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Phone: +34 624 64 41 37"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CookiesComponent_CookiesComponent = (CookiesComponent);

// EXTERNAL MODULE: ./components/HeadComponent/HeadComponent.tsx
var HeadComponent = __webpack_require__(65722);
;// CONCATENATED MODULE: ./pages/cookies.tsx





var Cookies = function Cookies() {
    var headerProps = {
        title: "Pol\xedtica de cookies",
        keywords: "Asesor\xeda energ\xe9tica, Consultor\xeda energ\xe9tica, Optimizaci\xf3n energ\xe9tica, \n        Asesoramiento el\xe9ctrico, Renovables, energ\xedas Renovables, eficiencia energ\xe9ticas,\n        consultor\xeda de software, asesoramiento de software, Comparativa de Tarifas, Comparativa de Energ\xe9tica,\n        Comparativa de luz, Comparativa de luz y gas, Comparativa de gas",
        content: "Pol\xedtica de cookies de Fiva, en Fiva te informamos sobre el uso completo de tus datos"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FivaLayout/* default */.Z, {
        blue: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadComponent/* default */.Z, (0,_object_spread/* default */.Z)({}, headerProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesComponent_CookiesComponent, {})
        ]
    });
};
/* harmony default export */ var cookies = (Cookies);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,9453,1552,1146,9774,2888,179], function() { return __webpack_exec__(89498); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);